// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","textPrimaryColor":"#ffffff","textActiveColor":"#7cf4fe"};